import { Reveal, Eyebrow } from "@/components/Reveal";
import QuoteForm from "@/components/quote/QuoteForm";

export default function Quote() {
  return (
    <main className="pt-40 pb-24 px-4 sm:px-8 lg:px-16" data-testid="quote-page">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <Eyebrow>Project Quote</Eyebrow>
          <h1 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Illuminate Your Course
          </h1>
          <p className="mt-6 text-muted-green text-base leading-relaxed max-w-xl">
            A four-step brief — two minutes now saves a week of back-and-forth later.
            Your information stays private and is only used to prepare your proposal.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 bg-card-dark border hairline rounded-md p-7 sm:p-10 grain relative">
            <QuoteForm />
          </div>
        </Reveal>
      </div>
    </main>
  );
}
